import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Autocomplete, Button, DialogActions, DialogContent, Grid2 as Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import { api, ui } from '../../../../interfaces/interfaces';
import bookingCycleMgr from '../../../../services/bookingCycleMgr';
import { newBooking } from '../../../../utilities/general';
import config from '../../../../utilities/config';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { getRandomAc } from './helpers';
import { phones } from './phones';
import { dispatchUILoaded, dispatchUILoading } from "@reducers/uiReducer";
import { useAppSelector } from "@store/hooks";

const handleClose = () => {
    ui.NewBookingDialogModal = false
    ui.FollowUpValue = ''
};
const handleNewBooking = async (navigate: NavigateFunction, accountCode: number) => {
    ui.DevSimulate = true
    dispatchUILoading();
    const account = await api.fetchAccountCode({ accountCode })
    if (account && !account.accountType?.startsWith('CARE')) {

        handleClose()
        if (account && account.accountCode)
            bookingCycleMgr.setBooking(ui.DevFrom ? 'call' : 'manual', account.accountCode, 0);
        await newBooking({ navigate, callFrom: Number(ui.DevFrom), accountCode: account.accountCode });
        dispatchUILoaded();
    }
    else {
        dispatchUILoaded();
        ui.ProblemMsg = 'Account not found'
        ui.ProblemMsgVariant = 'error'
        ui.ProblemShowMsg = true
    }
};

const NewBookingDialog: React.FC = () => {
    const NewBookingDialogModal = useAppSelector(({ ui }) => ui.NewBookingDialogModal);
    const [accountCode, setAccountCode] = React.useState('');
    const devFrom = useAppSelector(({ ui }) => ui.DevFrom);
    const navigate = useNavigate();

    return (
        (<Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={NewBookingDialogModal} maxWidth="sm" fullWidth>
            <DialogTitle id="simple-dialog-title">Create new booking</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <Paper elevation={2}>
                        <Typography variant="body1" sx={{ fontWeight: "bold", p: 1 }}>Please enter account code for new booking</Typography>
                    </Paper>
                    {config.debug && <Paper elevation={4}>
                        {/* <Grid item xs={12} sm={6}> */}
                        <Autocomplete
                            id="combo-box-number-from"
                            // className={ui.ProblemComboCategory ? classes.selection : classes.noSelection}
                            // displayEmpty
                            options={phones}
                            freeSolo
                            onChange={(e, v) => ui.DevFrom = v ? v : ""}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => <TextField {...params} label="Simulate call from past customer..." variant="outlined" />}
                            value={devFrom}
                        />
                    </Paper>}
                    <Grid container alignItems="center">
                        <Grid
                            textAlign="center"
                            size={{
                                xs: 6,
                                sm: 6
                            }}>
                            <Paper elevation={4} sx={{ mr: 1 }}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="accountCode"
                                    label="Account Code"
                                    type="number"
                                    variant="standard"
                                    fullWidth
                                    onChange={(e) => setAccountCode(e.target.value)}
                                    value={accountCode}
                                    sx={{
                                        width: "85%",
                                        'input': {
                                            fontSize: "1.5rem",
                                            lineHeight: ".8rem",
                                        }
                                    }}
                                />
                            </Paper>
                        </Grid>
                        {config.debug && <Grid
                            textAlign="center"
                            size={{
                                xs: 6,
                                sm: 6
                            }}>
                            <Paper elevation={4}>
                                <Button sx={{ m: 2 }} variant="contained" color="primary" onClick={() => {
                                    setAccountCode(String(getRandomAc()))
                                }}>Random Code</Button>
                            </Paper>
                        </Grid>}
                    </Grid>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button color='error' variant='outlined' onClick={handleClose}>Cancel</Button>
                <Button color='success' variant='contained' onClick={() => handleNewBooking(navigate, Number(accountCode))} disabled={accountCode.length !== 5}>Create</Button>
            </DialogActions>
        </Dialog >)
    );
}

export default React.memo(NewBookingDialog);